import * as version from './version.json';
import { WidgetsNames } from '@tango/app/interfaces';

import {
  colorValues as coreColorValues,
  usernameFormat as coreUsernameFormat,
} from '@tango/app/assets/constants';
import { ColorValues, UsernameFormat } from '@tango/app/interfaces';

export const rootUrl = 'http://localhost:3000';
export const appVersion =
  version.major +
  '.' +
  version.minor +
  '.' +
  version.patch +
  ' (' +
  version.date +
  ')';

export const clientVersion =
  version.major + '.' + version.minor + '.' + version.patch;

export const bankName = {
  uk: `АТ “Полтава-Банк“`,
  ru: `АО “Полтава-Банк“`,
  eng: `JSC “Poltava-bank”`,
};

export const appPublisherName = bankName;

export const bankLinks = {
  parentBank: 'https://www.poltavabank.com',
  googlePlay:
    'https://play.google.com/store/apps/details?id=online.kapowai.online.kapowai.poltavabank',
  appStoreLink:
    'https://apps.apple.com/us/app/полтава-банк-онлайн/id1542995453',
};
export const bankSupportPhone = '0532 610 002';
export const bankAddress = `АТ “Полтава-Банк“
                            Код ЄДРПОУ TODO
                            Адреса: TODO
                            Код Банку: TODO`;
export const bankChairpersonTitle = 'TODO';
export const bankChairpersonName = 'TODO';

export const colorValues: ColorValues = Object.assign({}, coreColorValues, {
  primary: '#E31F25',
  primaryDark: '#B31D22',
  primaryLight: '#FBECED',
  accentAttention: '#E31F25',
  accentAttentionDark: '#B31D22',
  accentSuccess: '#00A94F',
  accentSuccessDark: '#00823D',
  accentOther: '#E31F25',
  accentOtherDark: '#B31D22',
  accentAdditional: '#E31F25',
  accentAdditionalDark: '#B31D22',
  grayDark: '#3E3F42',
  gray: '#525B66',
  grayLight: '#9DA0A8',
  grayLightest: '#F4F4F4',
});

export const usernameFormat: UsernameFormat = Object.assign(
  {},
  coreUsernameFormat,
  {
    inputPrefix: '+380',
    isInputPrefixUnremovable: false,
    inputPattern: [
      '+',
      3,
      8,
      0,
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      /\d/,
    ],
  }
);

export const widgetsNames: WidgetsNames = {
  accounts: 'accounts-widget',
  currencies: 'dashboard-currency-widget',
  transactions: 'transactions-widget',
  credits: 'bank-credits-widget',
};
